export const MODAL_ALERT = 'MODAL_ALERT';

export const MODAL_CREATE_PROJECT = 'MODAL_CREATE_PROJECT';
export const MODAL_DELETE_PROJECT = 'MODAL_DELETE_PROJECT';
export const MODAL_CLONE_PROJECT = 'MODAL_CLONE_PROJECT';

export const MODAL_CREATE_PROJECTUNIT = 'MODAL_CREATE_PROJECTUNIT';
export const MODAL_EDIT_PROJECTUNIT = 'MODAL_EDIT_PROJECTUNIT';
export const MODAL_DELETE_PROJECTUNIT = 'MODAL_DELETE_PROJECTUNIT';
export const MODAL_CLONE_PROJECTUNIT = 'MODAL_CLONE_PROJECTUNIT';

export const MODAL_SAVE_PRODUCT_SYSTEM_ITEMS = 'MODAL_SAVE_PRODUCT_SYSTEM_ITEMS';

export const MODAL_EDIT_PRODUCT_SOLUTION = 'MODAL_EDIT_PRODUCT_SOLUTION';
export const MODAL_DELETE_PRODUCT_SOLUTION = 'MODAL_DELETE_PRODUCT_SOLUTION';

export const MODAL_DEACTIVATE_PROJECT = 'MODAL_DEACTIVATE_PROJECT';
export const MODAL_REACTIVATE_PROJECT = 'MODAL_REACTIVATE_PROJECT';

export const MODAL_CATCH_UNAUTHORIZED_SAVE_SOLUTION = 'MODAL_CATCH_UNAUTHORIZED_SAVE_SOLUTION';

export const MODAL_SHOW_DATENSCHUTZ = 'MODAL_SHOW_DATENSCHUTZ';
export const MODAL_SHOW_TERMS_OF_USE = 'MODAL_SHOW_TERMS_OF_USE';

export const MODAL_EDIT_PROJECT_SOLUTION_METADATA = 'MODAL_EDIT_PROJECT_SOLUTION_METADATA';

export const MODAL_SHOW_WIZARD_INFO = 'MODAL_SHOW_WIZARD_INFO';

export const MODAL_DOWNLOAD_REVIT_ERROR = 'MODAL_DOWNLOAD_REVIT_ERROR';



// WEBPACK FOOTER //
// ./src/components/Modals/modalTypes.js